import { render } from "./HeroiconsSolidBeaker.vue?vue&type=template&id=6bf300d0"
const script = {}

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidBeaker.vue"]])

export default __exports__